// those are just some of my svgs transformed into react components

export const KatsoLogoSVG = ({ className }) => (
	<svg version="1.0" xmlns="http://www.w3.org/2000/svg" className={className}
		viewBox="0 0 3840.000000 3840.000000"
		preserveAspectRatio="xMidYMid meet">
		<g transform="translate(0.000000,3840.000000) scale(0.100000,-0.100000)" stroke="none">
			<path d="M4632 33771 c2 -5 3544 -6565 7873 -14579 l7870 -14571 6698 -1 c3863 0 6697 4 6695 9 -1 5 -3544 6565 -7873 14579 l-7870 14571 -6698 1 c-3867 0 -6697 -4 -6695 -9z" />
			<path d="M19359 33763 c5 -10 1757 -3253 3893 -7207 2136 -3953 3887 -7189 3892 -7190 5 -1 6454 14006 6616 14372 l19 42 -7215 0 c-6868 0 -7214 -1 -7205 -17z" />
			<path d="M4620 17963 l0 -13343 7206 0 c6778 0 7206 1 7200 17 -7 18 -14328 26534 -14377 26618 l-29 50 0 -13342z" />
		</g>
	</svg>
)

export const CodebergLogoSVG = ({ className, id }) => (
	<svg
		viewBox="0 0 4.233 4.233"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		id={id}
	>
		<title>{"Codeberg logo"}</title>
		<defs>
			<linearGradient id="a">
				<stop
					style={{
						stopColor: "#2185d0",
						stopOpacity: 0,
					}}
					offset={0}
				/>
				<stop
					offset={0.495}
					style={{
						stopColor: "#2185d0",
						stopOpacity: 0.48923996,
					}}
				/>
				<stop
					style={{
						stopColor: "#2185d0",
						stopOpacity: 0.63279623,
					}}
					offset={1}
				/>
			</linearGradient>
			<linearGradient
				xlinkHref="#b"
				id="c"
				x1={42519.285}
				y1={-7078.789}
				x2={42575.336}
				y2={-6966.931}
				gradientUnits="userSpaceOnUse"
			/>
			<linearGradient id="b">
				<stop
					style={{
						stopColor: "#2185d0",
						stopOpacity: 0,
					}}
					offset={0}
				/>
				<stop
					offset={0.495}
					style={{
						stopColor: "#2185d0",
						stopOpacity: 0.30000001,
					}}
				/>
				<stop
					style={{
						stopColor: "#2185d0",
						stopOpacity: 0.30000001,
					}}
					offset={1}
				/>
			</linearGradient>
		</defs>
		<path
			style={{
				fontVariationSettings: "normal",
				opacity: 1,
				vectorEffect: "none",
				fill: "url(#c)",
				fillOpacity: 1,
				stroke: "none",
				strokeWidth: 3.67846,
				strokeLinecap: "butt",
				strokeLinejoin: "miter",
				strokeMiterlimit: 2,
				strokeDasharray: "none",
				strokeDashoffset: 0,
				strokeOpacity: 1,
				paintOrder: "stroke markers fill",
				stopColor: "#000",
				stopOpacity: 1,
			}}
			d="M42519.285-7078.79a.76.568 0 0 0-.738.675l33.586 125.888a87.182 87.182 0 0 0 39.381-33.763l-71.565-92.52a.76.568 0 0 0-.664-.28z"
			transform="matrix(.02428 0 0 .02428 -1030.156 172.97)"
		/>
		<path
			style={{
				opacity: 1,
				fill: "#2185d0",
				fillOpacity: 1,
				strokeWidth: 17.0055,
				paintOrder: "markers fill stroke",
				stopColor: "#000",
			}}
			d="M11249.461-1883.696c-12.74 0-23.067 10.327-23.067 23.067 0 4.333 1.22 8.58 3.522 12.251l19.232-24.863c.138-.18.486-.18.624 0l19.233 24.864a23.068 23.068 0 0 0 3.523-12.252c0-12.74-10.327-23.067-23.067-23.067z"
			transform="translate(-1030.156 172.97) scale(.09176)"
		/>
	</svg>
)

export const YaMusicLogoSVG = ({ className, id }) => (
	<svg
		className={className}
		viewBox="0 0 165 165"
		xmlns="http://www.w3.org/2000/svg"
		id={id}
	>
		<path
			d="M33.983 16.865a82 82 0 0 1 41.44-15.783v24.744a57.4 57.4 0 1 0 63.681 45.747l20.778-16.704-.014-.135A82 82 0 1 1 33.983 16.865Z"
			fill="#FCCA00"
		/>
		<path
			d="m144.215 28.414.087.218-13.885 22.053a57.69 57.69 0 0 0-19.735-18.12v50.187c0 15.398-12.482 27.88-27.88 27.88-15.397 0-27.88-12.482-27.88-27.88s12.483-27.88 27.88-27.88a27.75 27.75 0 0 1 15.58 4.756V2.23c18.101 3.482 34.084 12.915 45.833 26.184Z"
			fill="#FC3F1D"
		/>
	</svg>
)

export const AnilistLogoSVG = ({ className, id }) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="xMidYMid"
		viewBox="0 0 172 172"
		id={id}
	>
		<path
			d="M111.322 111.157V41.029c0-4.019-2.217-6.237-6.236-6.237H91.365c-4.019 0-6.237 2.218-6.237 6.237v33.304c0 .938 9.037 5.293 9.273 6.214 6.885 26.902 1.496 48.433-5.031 49.438 10.672.528 11.846 5.659 3.897 2.153 1.216-14.354 5.961-14.326 19.602-.528.117.119 2.797 5.741 2.964 5.741h32.217c4.019 0 6.236-2.217 6.236-6.236v-13.721c0-4.019-2.217-6.237-6.236-6.237h-36.728Z"
			style={{
				fillRule: "evenodd",
				fill: "#02a9ff",
			}}
		/>
		<path
			d="M54.365 34.792 18.331 137.351h27.996l6.098-17.74h30.49l5.96 17.74h27.857L80.836 34.792H54.365Zm4.435 62.09 8.731-28.412 9.563 28.412H58.8Z"
			style={{
				fill: "#fefefe",
				fillRule: "evenodd",
			}}
		/>
	</svg>
)

